import styled from 'styled-components';

export const RecoveryPhoneFormWrapper = styled.div`
  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 10px;
  }

  h4 {
    margin-top: 12px;
    font-size: 26px;
    font-weight: normal;
    line-height: 30px;
    color: #000;
  }

  .login-form {
    width: 460px;
    border: 1px solid #d4deed;
    background-color: #fff;
    /* height: 230px; */
    border-radius: 8px;
    padding: 35px 30px 6px 30px;

    &__inputs {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .ant-form-item {
        width: 100%;
      }

      .ant-col {
        display: flex;
        align-items: flex-start;
      }

      .ant-form-item-control-input {
        width: 100%;
      }
    }

    &__error {
      width: 100%;
      margin-bottom: 20px;
    }
  }
`;
